import { useState, useRef, useEffect } from 'react';
import { Box, Card, Text, Button, styled } from '@/theme/index';

const ObituaryText = styled(Text)(() => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const SeeMoreButton = styled(Button)(() => ({
  color: '#000',
  padding: '0',
  opacity: 0.8,
  textDecoration: 'underline',
  float: 'right',
}));

const StyledFullObituaryContainer = styled(Box)(({ theme }) => ({
  width: '100vw',
  [theme.breakpoints.up('sm')]: {
    width: '100%',
  },
}));

export function FullObituary({
  personName,
  text,
}: {
  personName: string;
  text: string;
}) {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [isLongText, setIsLongText] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (textRef.current) {
      const maxHeight =
        parseFloat(window.getComputedStyle(textRef.current).lineHeight) * 5;
      if (textRef.current.scrollHeight > maxHeight) {
        setIsLongText(true);
      }
    }
  }, [text]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  if (!text) {
    return null;
  }

  return (
    <StyledFullObituaryContainer>
      <Card id="full-obituary-section" sx={{ boxShadow: 'none' }}>
        <Text variant="h2" data-cy="report-section-title-text">
          {personName.split(' ')[0]}&apos;s Full Obituary
        </Text>
        <ObituaryText
          ref={textRef}
          lineHeight={1.5}
          data-cy="full-obituary"
          sx={{
            WebkitLineClamp: isCollapsed ? 5 : 'unset',
            maxHeight: isCollapsed ? `${5 * 1.5}em` : 'none',
          }}
        >
          {text}
        </ObituaryText>
        {isLongText && (
          <SeeMoreButton onClick={toggleCollapse}>
            {isCollapsed ? 'Read More' : 'Read Less'}
          </SeeMoreButton>
        )}
      </Card>
    </StyledFullObituaryContainer>
  );
}
